import Vue from 'vue';

export default () => Vue.$http
    .get('Products/count');




// WEBPACK FOOTER //
// ./src/services/product/countAll.js